import { all, call, takeLatest, delay, put } from "redux-saga/effects";
import queryString from "query-string";

import { getErrorMessage } from "../../../../../utils/sagasErrorHandler";
import { QUICK_START_DATA } from "../../../constants";
import { sharedHistory } from "../../../../../routes/sharedHistory";
import { ROUTES_MAP } from "../../../../../routes/constants";
import { CONFIG_MANAGER_LIGHT_STEPS } from "../../../index";
import { ITEMS_PER_PAGE } from "../../../../../constants/general";
import { getTracksRequest } from "../../../../Tracker/services/Tracks/api";
import { TRACKER_GENERAL_FILTER } from "../../../../Tracker/constants";
import { handleCheckTrackIds } from "../../../services/general/sagas";

import { requestFirsStep, setOneStep } from "./actions";
import { createConfigsRequest, createQuickStartRequest, getConfigsRequest } from "./api";

function* handleRequestFirsStep({ payload }){
    try {
        yield put(setOneStep({ isLoading: true, isOpen: true }));
        const { urls, template_code, branch_codes, receiver_code, ...restValues } = payload;
        const urlsArray = urls?.split("\n").filter(item => item);

        const filterParams = {
            offset: "0",
            limit: ITEMS_PER_PAGE,
            branch_codes,
            receiver_code,
            sandbox_mode: true
        };

        const { configs } = yield call(getConfigsRequest, filterParams);

        if(!configs.length) {
            yield call(createConfigsRequest, { ...restValues, branch_code: branch_codes, receiver_code });
            yield delay(60000);
        }

        const dataQuickStart = {
            ...QUICK_START_DATA,
            branch_code: branch_codes,
            receiver_code
        };

        const quickStart = yield all(urlsArray.map((url) => call(createQuickStartRequest, { ...dataQuickStart, url })));

        const initial_track_ids = quickStart.map(({ track_id: { initial_track_id } }) => initial_track_id);
        const track_id = quickStart[0].track_id.track_id;
        const initial_track_id = quickStart[0].track_id.initial_track_id;

        yield handleCheckTrackIds(initial_track_ids);
        yield put(setOneStep());


        const { scrape_tasks } = yield call(getTracksRequest, {
            ...TRACKER_GENERAL_FILTER,
            branch_codes,
            receiver_code,
            initial_track_id
        });

        const searchParams = {
            branch_codes,
            receiver_code,
            track_id,
            storage_type_code: "HOT",
            initial_track_id: initial_track_ids,
            template_code: scrape_tasks[0].actual_template_code
        };

        sharedHistory.push(
            `${ROUTES_MAP.configManagerLite.path}/${CONFIG_MANAGER_LIGHT_STEPS.two}?${queryString.stringify(searchParams)}`
        );
    } catch (error) {
        yield put(setOneStep());
        getErrorMessage(error);
    }
}

export function* stepOneSagas() {
    yield all([
        yield takeLatest(requestFirsStep, handleRequestFirsStep)
    ]);
}
